<template>
  <div>
    <v-row class="header-state-view">
      <v-col cols="12" class="py-0">
        <v-card-title class="headline white--text" primary-title
          >Process Detail Search</v-card-title
        >
      </v-col>
    </v-row>
    <v-row class="pb-12 custom-form-control custom-figma-1 custom-bg-window">
      <v-col cols="12" class="pt-0 pb-0">
        <div class="py-4 pl-8 pr-11 fixed-height-comp">
          <processDetail
            class="list-table admin-process-style srm-list-table custom-border-table"
            :processId="this.$route.params.id"
          />
        </div>
      </v-col>
      <v-col class="py-0 mt-8" lg="12">
        <div class="px-8 text-right">
          <v-btn class="btn btn-delete" @click="closeWindow('btn-close')">Close</v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import processDetail from '@/vue-caas/views/admin/ProcessSearchDetail.vue';

const moment = require('moment');

export default {
  props: {},
  components: {
    processDetail,
  },
  name: 'process-detail-view-window',

  data() {
    return {
      processViewArr: [],
    };
  },

  created() {},

  methods: {
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },
  },
};
</script>

<style>
.custom-bg-window {
  background-color: #25272e !important;
}
</style>
